<template>
    <div v-if="!loading && cards" class="w-full flex flex-column gap-3">
        <div v-if="total && total>10 && count" class="flex flex-1 align-items-center">
            <span class="text-xs text-400">{{ count }} из {{ total }} {{ content[lang_].trans }}</span>
        </div>

        <div v-if="cards.length>0" class="flex grid align-items-left overflow-hidden justify-content-start">

            <div v-for="card of cards" @click="goToCard(card.id)" :key="card.id"
                class="flex flex-row xl:flex-column lg:flex-column md:flex-column
                    col-12 xl:col-4 lg:col-4 md:col-6
                    gap-3 xl:gap-1 lg:gap-1 md:gap-1 
                    mb-0 xl:mb-3 lg:mb-3 md:mb-3">
                <div class="flex 
                    w-6 xl:w-auto lg:w-auto md:w-auto
                    max-w-10rem xl:max-w-full lg:max-w-full md:max-w-full">
                    <div class="w-full relative cursor-pointer border-round-lg xl:border-round-2xl lg:border-round-2xl md:border-round-xl" 
                        :style="{ background: getBackground(card) }"
                        style="padding-bottom:67%;">
                        <div class="absolute top-0 left-0 pt-2 pl-2">
                            <span class="text-lg font-medium" :style="{ color: getColor(card) }">
                                {{ card.last4 }}
                            </span>
                        </div>
                        <div class="absolute bottom-0 right-0 pb-2 pr-2">
                            <span class="text-xs font-medium" :style="{ color: getColor(card) }">
                                {{ card.brand }}
                            </span>
                        </div>
                    </div>
                </div>
                <div class="flex flex-1 flex-column gap-1 pt-2">
                    <span v-if="card.title" class="flex text-900 text-lg font-medium text-right">
                        {{ getFormatAmount(card.balance, card.currency_code, 2) }}
                    </span>
                    <span class="flex flex-1 text-sm text-left text-400 uppercase">
                       {{ card.balance }} {{ card.currency_code }}
                    </span>
                </div>
                <!-- <div class="flex">
                    <span class="flex text-900 text-sm font-medium text-right">
                        {{ get_format_amount(card.balance, card.currency_code) }} 
                    </span>
                </div> -->
            </div>
            <Paginator v-if="total && total>10" :rows="10" :first="skip" :totalRecords="total" :rowsPerPageOptions="[10, 20, 30]" @update:first="onChangePage" 
                template="PrevPageLink PageLinks NextPageLink" />
        </div>
    </div>
    <Skeleton v-if="loading" height="2rem" class="mb-3" />
</template>

<script>
import Connect from         '@/assets/js/Connect'
import Helper from          '@/assets/js/Helper'
import CardsTemplate from   '@/assets/json/vcards.json'

export default {
    props: {
        cards: { 
            type: Array, 
            default: () => [] 
        },
        skip: { 
            type: Number, 
            default: 10
        },
        total: { 
            type: Number, 
            default: 0 
        },
        loading: { 
            type: Boolean, 
            default: true 
        }
    },
    data() {
        return {
            content: {
                en: { 
                    empty: 'No card',
                    trans: 'cards'
                },
                ru: { 
                    empty: 'Нет карт',
                    trans: 'карт'
                }
            },
            count: 0,
            cardsTemplate: CardsTemplate
        }
    },
    computed: {
        lang_() { return (this.$i18n.locale) ? this.$i18n.locale : 'ru' },
    },
    watch: {
        transactions: {
            handler: function (val) {
                if(val){
                    this.count = val.length + this.skip
                    if(this.count > this.total) this.count = this.total
                }
            },
            deep: true
        }
    },
    methods: {
        getFormatAmount(value, currency, digits = 2) {
            if(!value) return 0
            return this.helper.format_amount(value, currency, digits)
        },
        getFormatDate(date) {
            return this.helper.format_date_short(date)
        },
        onChangePage(event) {
            this.$emit('update:first', event)
        },
        onChangeRows(event) {
            this.$emit('update:rows', event)
        },
        goToCard(id) {
            this.$router.push({ path: '/personal/card/' + id })
        },
        getBackground(card){
            if(!card || !card.program_id) return '#f0f0f0'
            const cardData = this.cardsTemplate.find(c => c.program_id === card.program_id)
            if(cardData && cardData.background) return cardData.background
            return '#f0f0f0'
        },
        getColor(card){
            if(!card || !card.program_id) return '#000000'
            const cardData = this.cardsTemplate.find(c => c.program_id === card.program_id)
            if(cardData && cardData.color) return cardData.color
            return '#000000'
        },
    },
    async beforeCreate(){
        this.connect = new Connect()
        this.helper = new Helper()
    },
}
</script>